import { render, staticRenderFns } from "./IndividualService.vue?vue&type=template&id=75ec637e&scoped=true"
import script from "./IndividualService.vue?vue&type=script&lang=js"
export * from "./IndividualService.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/home.css?vue&type=style&index=0&id=75ec637e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ec637e",
  null
  
)

export default component.exports